module.exports = "<svg viewBox=\"0 0 9.6 15.1\" height=\"15.1px\" width=\"9.6px\">\n<polygon class=\"control-svg\" fill=\"#000111\" points=\"9.6,7.5 0,15.1 0,0 \"/>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/play.svg
// module id = 346
// module chunks = 0